import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'BASE_DATA_CURRENCY',
    icon: 'menu-currency',
    label: '币种',
    path: '/base-data/currency',
  },
] satisfies Menu[];
